<template>
  <div class="p-20px">
    <div class="mb-20px">
      <div class="flex items-center justify-between">
        <div class="w-35px h-35px" @click="goBack">
          <img src="@/assets/images/mine/left.webp" alt="" class="w-full h-full">
        </div>
        <div class="color-#fff text-14px">
          {{ t('settings.title') }}
        </div>
        <div class="w-35px h-35px">

        </div>
      </div>
    </div>
    <div class="invite_friends">
      <div class="p-15px liwu_box pb-0px">
        <div class="p-15px liwu flex items-center justify-center">
          <div class="w-24px h-24px flex items-center justify-center">
            <img src="@/assets/images/store/liwu.webp" alt="" class="w-full h-full">
          </div>
          <div class="text-16px font-800 mx-4px ">
            Invite friends,earn to 100
          </div>
          <div class="w-12px h-12px flex items-center justify-center">
            <img src="@/assets/images/home/crystal.webp" class="w-full h-full" />
          </div>
        </div>
      </div>
      <div class="p-15px">
        <div class="mt-15px text-14px font-500">
          Invitation Code
        </div>
        <div class="share flex items-center justify-between pl-20px mt-20px">
          <div class="flex items-center ">
            <div class="">
              {{ userStore.userInfo?.userId }}
            </div>
            <div class="w-16px h-16px flex items-center justify-center ml-30px" @click="handelCopy(userStore.userInfo?.userId)">
              <img src="@/assets/images/setting/copy.webp" alt="" class="w-20px h-20px">
            </div>
          </div>
          <div class="share_box pl-20px">
            Share
          </div>
        </div>
        <div class="mt-15px mb-15px text-14px font-500">
          Redemption code
        </div>
        <div class="share flex items-center justify-between pl-20px">
          <input type="text" placeholder="Please input" v-model="shareCode">
          <div class="share_box pl-20px" @click="saveShareCode">
            Submit
          </div>
        </div>
        <div class="text-12px mt-20px text-center color-#FFFFFF66 w-100%">
          Number of people invited
        </div>
        <div class="flex items-center justify-center mt-20px">
          <div class="w-20px h-20px flex items-center justify-center">
            <img src="@/assets/images/setting/ren.webp" alt="" class="w-full h-full">
          </div>
          <div class="ml-8px">
            0
          </div>
        </div>
      </div>
    </div>
    <!-- 设置列表 -->
    <div class="settings-list">
      <div class="setting-item" @click="goEditProfile">
        <div class="left relative">
          <img src="@/assets/images/mine/edit_profile.svg" alt="" class="w-20px mr-12px">
          <span class="text">{{ t('settings.editProfile') }}</span>
          <span class="dot" v-if="!isEditInfo"></span>
        </div>
      </div>
      <!-- <div class="setting-item">
        <div class="left">
          <img src="@/assets/images/setting/notification.svg" alt="" class="w-20px mr-12px">
          <span class="text">{{ t('settings.systemNotification') }}</span>
        </div>
        <div class="w-28px h-12px flex item-centers ml-auto" @click="handleNotification">
          <img v-if="!isNotification" src="@/assets/images/setting/kai.svg" class="w-full h-full"></img>
        </div>
      </div> -->
      <div class="setting-item" @click="goFAQ">
        <div class="left">
          <img src="@/assets/images/mine/fqa.svg" alt="" class="w-20px mr-12px">
          <span class="text">{{ t('settings.faq') }}</span>
        </div>
        <!-- <span class="arrow">›</span> -->
      </div>


      <div class="setting-item" @click="openTerms">
        <div class="left">
          <img src="@/assets/images/mine/use.svg" alt="" class="w-20px mr-12px">
          <span class="text">{{ t('settings.termsOfUse') }}</span>
        </div>
        <!-- <span class="arrow">›</span> -->
      </div>

      <div class="setting-item" @click="openPrivacy">
        <div class="left">
          <img src="@/assets/images/mine/privacy_olicy.svg" alt="" class="w-20px mr-12px">
          <span class="text">{{ t('settings.privacyPolicy') }}</span>
        </div>
        <!-- <span class="arrow">›</span> -->
      </div>
      <div class="setting-item" @click="handleAboutAccount">
        <div class="left">
          <img src="@/assets/images/home/account.webp" alt="" class="w-20px mr-12px">
          <span class="text">{{ t('settings.aboutAccount') }}</span>
        </div>
        <!-- <span class="arrow">›</span> -->
      </div>
      <div class="setting-item" @click="clearCache">
        <div class="left">
          <img src="@/assets/images/mine/clean.svg" alt="" class="w-20px mr-12px"></img>
          <span class="text">{{ t('settings.clearCache') }}</span>
        </div>
      </div>
      <div class="setting-item" @click="deleteAccount">
        <div class="left">
          <img src="@/assets/images/mine/delete.svg" alt="" class="w-20px mr-12px"></img>
          <span class="text">{{ t('settings.deleteAccount') }}</span>
        </div>
        <!-- <span class="arrow">›</span> -->
      </div>

      <div class="setting-item" @click="handleLogout">
        <div class="left">
          <img src="@/assets/images/mine/out.svg" alt="" class="w-20px mr-12px"></img>
          <span class="text">{{ t('settings.logOut') }}</span>
        </div>
        <!-- <span class="arrow">›</span> -->
      </div>
    </div>
    <div class="color-#fff flex items-center justify-center mt-20px">
      <div class="w-25px h-20px flex items-center justify-center">
        <img src="@/assets/images/home/version.webp" alt="" class="w-full h-full mr-12px">
      </div>
      <div class="text-version">
        {{ t('settings.version') }} {{ version }}
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import { useRouter } from 'vue-router'
import { useUserStore } from '@/stores/user'
import { useDialog } from '@/composables/useDialog'
import { useLoginDialog } from '@/composables/useLoginDialog'
import { showLoadingToast, showToast, closeToast } from '@/utils/toast'
import theme from '@/styles/theme'
import bridge from '@/utils/bridge'
import { version } from '../../../package.json'
import { logEventSafe } from '@/plugins/firebase'
import { useI18n } from 'vue-i18n'
import { UserAPI } from '@/services/api'
const shareCode = ref('')
const { t } = useI18n()
const router = useRouter()
const userStore = useUserStore()
const dialog = useDialog()
const $loginDialog = useLoginDialog()
const isEditInfo = computed(() => userStore.getIsEditInfo())
const goEditProfile = () => {
  router.push({ name: 'EditProfile' })
}
// 这些变量将在clearCache函数中使用
const handleLogout = async () => {

  const confirmed = await dialog.confirm({
    title: t('settings.logOutTitle'),
    message: t('settings.logOutMessage'),
    confirmButtonText: t('common.confirm'),
    cancelButtonText: t('common.cancel'),
    confirmButtonColor: '#667eea'
  })
  if (confirmed) {
    bridge.callApp('appClose')
    // 先清除用户数据
    userStore.logOut()

    // 立即跳转到登录页面，避免路由守卫的检查循环
    $loginDialog.show()
  }
}
const goBack = () => {
  router.back()
}
const goFAQ = () => {
  router.push({ name: 'FAQ' })
}
const openTerms = () => {
  router.push({ name: 'Terms' })
}
const openPrivacy = () => {
  router.push({ name: 'Policy' })
}
const handleAboutAccount = () => {
  router.push({ name: 'Account' })
}
const deleteAccount = async () => {
  try {
    const confirmed = await dialog.confirm({
      title: t('settings.deleteAccountTitle'),
      message: t('settings.deleteAccountMessage'),
      confirmButtonText: t('common.confirm'),
      cancelButtonText: t('common.cancel'),
      confirmButtonColor: '#667eea'
    })

    if (confirmed) {
      try {
        showLoadingToast(t('settings.deletingAccount'))
        await userStore.deleteUser()
        showToast(t('settings.accountDeleted'), { type: 'success' })
        localStorage.removeItem('isNewUserLogin')
        localStorage.removeItem('first_pay_success_to_vippage')

        bridge.callApp('appClose')

        $loginDialog.show()
        // router.replace({ name: 'Login' })
      } catch (error) {
        console.log('User cancelled, error:', error)
      } finally {
        closeToast()
      }
    }
  } catch (error) {
    // 用户点击了取消或关闭
    console.log('User cancelled, error:', error)
  }
}
const clearCache = async () => {
  const confirmed = await dialog.confirm({
    title: t('settings.cacheTitle'),
    message: t('settings.cacheMessage'),
    confirmButtonText: t('common.confirm'),
    cancelButtonText: t('common.cancel'),
    confirmButtonColor: '#667eea'
  })
  if (confirmed) {
    logEventSafe('user_cache_cleaning')
    showLoadingToast(t('settings.cleaning'))
    // 🔧 备份重要数据（在清除缓存前备份）
    const token = userStore.getStoredToken()
    const appId = userStore.getAppId()
    const udid = userStore.getudid()

    // 调用app清除缓存
    bridge.callApp('appClearTheCache')

    // 🔧 修复：跳转后立即显示toast
    setTimeout(() => {
      // 恢复重要数据
      if (token) userStore.setToken(token)
      if (appId) userStore.setAppId(appId)
      if (udid) userStore.setudid(udid)
      localStorage.setItem('isNewUserLogin', '1')
      // 先跳转到首页
      router.push({
        path: '/'
      })

      // 🔧 在跳转后立即显示成功提示（通过延时确保页面加载完成）
      setTimeout(() => {
        showToast(t('settings.cleaningComplete'), { type: 'success', duration: 2000 })
      }, 100)
    }, 500)
  }
}

const handelCopy = async (type: any) => {
  const textToCopy = type
  try {
    // 优先尝试 App 原生复制能力（适用于 Flutter / React Native WebView）
    if (window.flutter_inappwebview) {
      await window.flutter_inappwebview.callHandler('appCopyToClipboard', { text: textToCopy })
      showToast('Copied to clipboard', { type: 'success' })
      return
    } else if (window.Android && typeof (window.Android as any).copyToClipboard === 'function') {
      (window.Android as any).copyToClipboard(textToCopy)
      showToast('Copied to clipboard', { type: 'success' })
      return
    }
    // 浏览器标准 Clipboard API
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(textToCopy)
      showToast('Copied to clipboard', { type: 'success' })
    } else {
      // execCommand 降级方案
      const textarea = document.createElement('textarea')
      textarea.value = textToCopy
      textarea.style.position = 'fixed'
      textarea.style.opacity = '0'
      document.body.appendChild(textarea)
      textarea.select()
      document.execCommand('copy')
      document.body.removeChild(textarea)
      showToast('Copied to clipboard', { type: 'success' })
    }
  } catch (err) {
    console.error('Copy failed:', err)
    showToast('Copy failed', { type: 'error' })
  }
}
const saveShareCode = async () => {
  showLoadingToast('Saving...')
  await UserAPI.getShareCode({
    inviter: shareCode.value
  })
  closeToast()
}
</script>

<style scoped lang="scss">
.settings-list {
  margin-top: 12px;

  .setting-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 40px;
    padding: 0 14px;
    border-radius: 12px;
    background: v-bind('theme.colors.backgroundSecondary');
    color: #fff;
    margin-bottom: 10px;

    .left {
      display: flex;
      align-items: center;

      .icon {
        margin-right: 10px;
        width: 20px;
        text-align: center;
      }

      .text {
        font-weight: 500;
        font-size: 14px;
        color: #FFFFFF;
      }

      .dot {
        position: absolute;
        top: 0px;
        right: -6px;
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background: #ff4d8d;
      }
    }

    .arrow {
      color: v-bind('theme.colors.textPrimary');
      font-size: 18px;
    }
  }
}

.text-version {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.5);
}

.invite_friends {
  width: 100%;
  height: 400px;
  border-radius: 10px;
  border: 3px solid rgba(255, 255, 255, 0.2);

  .liwu_box {
    border-bottom: 3px solid rgba(255, 255, 255, 0.2);
  }

  .liwu {

    background-color: rgba(255, 255, 255, 0.1);
  }

  .share {
    background-color: rgba(255, 255, 255, 0.1);
    border-radius: 24px;

    .share_box {
      background: linear-gradient(0deg, #5A68FF 0%, #95A5FF 100%);
      border-radius: 0px 28px 28px 0px;
      padding: 13px;
      padding: 13px 24px;
    }
  }
}
</style>